<button (click)="selectGenre.emit(genre)" [ngClass]="genre.isActive ? 'bg-primary text-white' : 'bg-white text-primary'"
  class="border border-primary px-4 py-1.5 rounded-md  md:hover:bg-primary md:hover:text-white w-full ">
  {{genre.name}}
</button>